import React from 'react'

const SvgSurfOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.608 4.277c-1.994.674-4.354 2.125-6.55 4.322a20.637 20.637 0 00-3.81 5.262c-.7 1.399-1.11 2.673-1.248 3.666l.009-.002.13-.034c.26-.07.586-.157.873-.2.173-.026.386-.046.603-.022.212.023.529.1.789.36.259.258.337.572.361.788.024.22.003.433-.024.605a8.317 8.317 0 01-.204.87l-.028.102c.993-.144 2.262-.556 3.651-1.253a20.636 20.636 0 005.241-3.798c2.197-2.197 3.648-4.557 4.322-6.551.337-.998.469-1.87.427-2.567-.042-.695-.251-1.158-.534-1.44-.283-.284-.746-.493-1.441-.535-.696-.042-1.569.09-2.567.427zM6.381 20.59v-.004.004zm-2.963-2.944h.002-.002zM18.283 2.063c.99.06 1.92.375 2.599 1.055.68.68.995 1.608 1.055 2.6.06.99-.13 2.099-.518 3.247-.776 2.298-2.395 4.887-4.752 7.244a22.43 22.43 0 01-5.704 4.132c-1.889.948-3.745 1.501-5.192 1.502-.32 0-.692-.12-.942-.461a1.32 1.32 0 01-.238-.78c-.003-.358.108-.772.183-1.05l.042-.156.067-.25a26.252 26.252 0 00-.421.111c-.283.074-.697.182-1.055.18a1.342 1.342 0 01-.77-.227 1.14 1.14 0 01-.48-.943c-.01-1.449.541-3.312 1.489-5.207a22.428 22.428 0 014.145-5.728c2.357-2.356 4.946-3.975 7.244-4.751 1.148-.388 2.258-.578 3.248-.518z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.598 3.402a.672.672 0 010 .95L6.405 18.545a.672.672 0 01-.95-.95L19.65 3.402a.672.672 0 01.95 0z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.311 13.835l2.904 2.91 3.34-3.333-1.06-1.062a2.283 2.283 0 00-1.132-.613 2.723 2.723 0 00-1.154.006 3.463 3.463 0 00-1 .39 4.056 4.056 0 00-.836.643l-1.062 1.06zm2.906.788l-.784-.786c.16-.159.338-.296.525-.404.187-.108.379-.184.564-.223a1.33 1.33 0 01.375-.03c.05.005.097.011.143.022.157.034.29.105.393.208l-1.216 1.213z'
    />
  </svg>
)

export default SvgSurfOutline
